const findLabel = (options = [], value) => options.find((item) => item.value === value)?.label ?? value

const getValidFormatLabelsForChannel = (channel, config) => {
  const formatValues = config.mediumRules
    .filter((rule) => rule.channel === channel)
    .flatMap((rule) => rule.formats)

  const uniqueLabels = [...new Set(formatValues)].map((formatValue) => findLabel(config.formats, formatValue))

  if (uniqueLabels.length <= 1) {
    return uniqueLabels[0] ?? ''
  }

  const last = uniqueLabels.pop()
  return `${uniqueLabels.join(', ')} або ${last}`
}

/**
 * Friendly UX copy for invalid channel + format pairs (preview panel only).
 */
export const getInvalidCombinationMessage = ({ channel, format, config }) => {
  const channelLabel = findLabel(config.channels, channel)
  const formatLabel = findLabel(config.formats, format)

  if (channel === 'google' && format !== 'ad') {
    return {
      title: 'Некоректна комбінація',
      message: `Google не використовується для ${formatLabel}-посилань.`,
      hint: 'Для Google оберіть формат Ad або змініть канал.',
    }
  }

  if (channel === 'email' && format !== 'email') {
    return {
      title: 'Некоректна комбінація',
      message: 'Email-канал підтримує лише формат Email.',
      hint: 'Оберіть формат Email або змініть канал.',
    }
  }

  if (channel === 'viber' && format !== 'broadcast') {
    return {
      title: 'Некоректна комбінація',
      message: 'Viber підтримує лише формат Broadcast.',
      hint: 'Оберіть формат Broadcast або змініть канал.',
    }
  }

  if (format === 'broadcast' && channel !== 'viber') {
    return {
      title: 'Некоректна комбінація',
      message: `Формат Broadcast не підходить для ${channelLabel}.`,
      hint: 'Оберіть канал Viber або змініть формат.',
    }
  }

  if (['instagram', 'facebook', 'telegram'].includes(channel) && format === 'email') {
    const suggestions = getValidFormatLabelsForChannel(channel, config)

    return {
      title: 'Некоректна комбінація',
      message: `Email-формат не підходить для ${channelLabel}.`,
      hint: `Оберіть ${suggestions}.`,
    }
  }

  if (channel === 'partner' && ['story', 'reel'].includes(format)) {
    return {
      title: 'Некоректна комбінація',
      message: `Partner / Referral не використовується для ${formatLabel}.`,
      hint: 'Оберіть Partner Post, Banner Ad або Post.',
    }
  }

  if (channel === 'partner' && format === 'ad') {
    return {
      title: 'Некоректна комбінація',
      message: 'Partner / Referral не підтримує формат Ad.',
      hint: 'Оберіть Partner Post, Banner Ad або Post.',
    }
  }

  if (['instagram', 'facebook', 'telegram'].includes(channel)) {
    const suggestions = getValidFormatLabelsForChannel(channel, config)

    return {
      title: 'Некоректна комбінація',
      message: `Формат ${formatLabel} не підходить для ${channelLabel}.`,
      hint: `Оберіть ${suggestions}.`,
    }
  }

  if (channel === 'partner') {
    return {
      title: 'Некоректна комбінація',
      message: `Формат ${formatLabel} не підходить для Partner / Referral.`,
      hint: 'Оберіть Partner Post, Banner Ad або Post.',
    }
  }

  return {
    title: 'Некоректна комбінація',
    message: `Комбінація ${channelLabel} + ${formatLabel} не підтримується для UTM.`,
    hint: 'Змініть канал або формат.',
  }
}

export default getInvalidCombinationMessage
